<template>
  <iframe ref="iframe" class="iframe-container" src="http://localhost:5173/" />
</template>
<script>
export default {
  name: 'workflowEdit'
}
</script>
<style lang="scss" scoped>
.iframe-container {
  width: 100%;
  height: calc(100% - 4px);
  border: none;
  padding: 0;
  margin: 0;
}
</style>